<template>
  <section class="hero" role="banner">
    <div class="buttons" v-if="slides.length > 1">
      <div v-for="index in slides.length"
           :key="index"
           :class="['a-button', `button${index}`, {'is-on': currentSlide === index}]"
           @click="showSlide(index)"
           :aria-label="`Slide ${index}`" :qa="'slide-btn-'+index">
      </div>
    </div>
    <div class="arrows" v-if="slides.length > 1">
      <div class="a-button arrow1" @click="prev">
        <i class="fal fa-chevron-left" aria-hidden="true" title="Previous slide"></i>
        <span class="sr-only">{{ $t('previousSlide') }}</span>
      </div>
      <div class="a-button arrow2" @click="next">
        <i class="fal fa-chevron-right" aria-hidden="true" title="Next slide"></i>
        <span class="sr-only">{{ $t('nextSlide') }}</span>
      </div>
    </div>
    <div class="slides" v-if="slides.length > 0" qa="banner-slider" v-hammer:pan.horizontal="onPanHorizontal">
      <transition-group duration="500" enter-active-class="animated slide-in" leave-active-class="animated slide-out">
        <template v-for="(slide, index) in slides">
          <section :class="['slide', `slide${slide.id}`, { 'background-image-right': $isCnmiIwsf, 'background-image': !$isCnmiIwsf, 'background-image-centre' : isScienceDay || isStateScienceDay }]"
                   :key="`slide${slide.id}`"
                   v-show="currentSlide === index+1"
                   :style="backgroundStyle(slide.background)"
          >
          <div v-bind:class="{ centerDiv: $isAjas, 'wrapper': slide.isRegion, 'text-container': $isEngCom }">
            <div v-if="($isAjas) || slide.isRegion" :class="{ 'image-container floatLeft': $isAjas, 'region-logo': slide.isRegion }">
              <img class="img-logo" :src="slide.logo.image">
            </div>
            <Snowf v-if="isChristmasTime" :amount="50" :size="5" :speed="snowSpeed" :wind="0" :opacity="0.8" :swing="snowSwing" :image="null" :zIndex="null" :resize="true" color="#fff" />
            <!-- a named scoped slot that exposes the title of the banner for consumption by the parent -->
            <div class="text"  v-if="slide.title" >
              <!-- a named scoped slot that exposes the title of the banner for consumption by the parent -->
              <slot name="title"
                    v-bind:title="{index: index+1, title: slide.title}">
                <img v-if="slide.title.imageFirst" class="image" :src="slide.title.imageFirst" :alt="slide.title.imageAltText">
                <h2 v-if="slide.title.title" class="title" :class="{'uppercase':$isEngCom && index === 2 }">{{ slide.title.title }}</h2>
                <img v-if="slide.title.image" class="image" :src="slide.title.image" :alt="slide.title.imageAltText">
              </slot>
              <!-- Doesn't show subtitle if it doesnt exist or matches the subtitle for the CSAP region -->
              <p class="region-subtitle" v-if="slide.subtitle && slide.subtitle != 'Conseil scolaire acadien provincial STEM Fair'">
                <slot name="subtitle" v-bind:subtitle="{index: index+1, subtitle: slide.subtitle}">
                  <span v-html="slide.subtitle" class="is-hidden-mobile"></span>
                  <span v-html="'Regional Fair'" class="is-hidden-tablet"></span>
                </slot>
              </p>
              <p class="description" v-if="slide.description" :class="{ 'is-hidden-mobile': slide.isRegion}">
                <!-- a named scoped slot that exposes the description of the banner for consumption by the parent -->
                <slot name="description" v-bind:description="{index: index+1, description: slide.description}">
                  <span v-if="slide.description" v-html="slide.description"></span>
                </slot>
              </p>
              <!-- a named scoped slot that exposes the container of the banner for consumption by the parent -->
              <slot name="content" v-bind:content="{index: index+1, content: slide.content}">
                <div class="link-container" v-if="slide.content && (!!slide.content.link && !!slide.content.link1 )">
                  <a v-if="slide.content.link1 && slide.content.link1.text !== '' && slide.isRegion"
                     class="link uppercase"
                     :href="slide.content.link1.href" target="_blank" :aria-label="slide.content.link1.text">
                    {{slide.content.link1.text}}
                  </a>
                  <a v-if="slide.content.link2 && slide.content.link2.text !== '' && slide.isRegion"
                     class="link uppercase"
                     :href="slide.content.link2.href" target="_blank" :aria-label="slide.content.link2.text">
                    {{slide.content.link2.text}}
                  </a>
                  <a v-if="slide.content.link" @click="openLink(slide.content.link.url, slide.content.link.paramName, slide.content.link.paramValue)"
                     class="link uppercase" :class="{'transparent': slide.content.link.style === 'transparent'}"
                     :href="slide.content.link.href" target="_blank" :aria-label="slide.content.link.text">
                    {{slide.content.link.text}}
                  </a>
                  <button v-if="slide.content.button && !!slide.content.button.url "
                          @click="openLink(slide.content.button.url, slide.content.button.paramName, slide.content.button.paramValue)" class="link right-button uppercase padding-right"
                          :class="{'yokogawa': slide.content.button.style === 'yokogawa'}"
                          :aria-label="slide.content.button.text">
                    <i v-if="slide.content.button.icon" :class="slide.content.button.icon"></i>
                    {{slide.content.button.text}}
                  </button>
                  <button v-if="slide.content.button2 && slide.content.button2.text"
                          @click="openLink(slide.content.button2.url, slide.content.button2.paramName, slide.content.button2.paramValue)" class="link right-button uppercase padding-right"
                          :class="{'yokogawa': slide.content.button2.style === 'yokogawa'}"
                          :aria-label="slide.content.button2.text">
                    <i v-if="slide.content.button2.icon" :class="slide.content.button2.icon"></i>
                    {{slide.content.button2.text}}
                  </button>
                </div>
              </slot>
            </div>
          </div>
          </section>
        </template>
      </transition-group>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import Snowf from 'vue-snowf'
import { VueHammer } from 'vue2-hammer'
import throttle from 'lodash/throttle'

Vue.use(VueHammer)

export default {
  name: 'genericBanner',
  components: { Snowf },
  data: function () {
    return {
      currentSlide: 0,
      timeout: null
    }
  },
  mounted: function () {
    this.showSlide(this.startingSlide)
  },
  computed: {
    isReducedMotion: function () {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    },
    snowSpeed: function () {
      return this.isReducedMotion ? 0 : 1.5
    },
    snowSwing: function () {
      return this.isReduceMotion ? 0 : 1
    },
    slidesSpeed: function () {
      if (this.$isEngCom) {
        return 5000
      } else {
        return 50000
      }
    }
  },
  props: {
    isChristmasTime: Boolean,
    startingSlide: {
      type: Number,
      default: 1
    },
    slides: {
      type: Array,
      default: () => {
        return [{
          title: 'Sample Title 1',
          background: { color: '#000' },
          description: '<strong>Slide 1 Description</strong>',
          content: {
            link: {
              text: 'Click Me',
              onClickFunc: () => {
                alert('clicked on slide 1 link')
              }
            }
          }
        }, {
          title: 'Sample Title 2',
          background: { color: '#000' },
          description: 'Slide 2 Description',
          content: {
            link: {
              text: 'Click Me',
              onClickFunc: () => {
                alert('clicked on slide 2 link')
              }
            }
          }
        }]
      }
    }
  },
  methods: {
    subEventParam: function () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return this.$route.path.substring(1)
    },
    isScienceDay: function () {
      return this.subEventParam === 'scienceday'
    },
    isStateScienceDay: function () {
      return this.subEventParam === 'state-science-day'
    },
    openLink: function (link, addOn = '', addOnValue = '') {
      if (link.startsWith('http')) {
        window.open(link)
      } else if (link.startsWith('show')) {
        this.$store.dispatch('showLoginModal', { addOn: addOnValue })
      } else if (link.startsWith('/')) {
        this.$router.push(link)
      }
    },
    prev: throttle(function () {
      if (this.currentSlide === 1) {
        this.showSlide(this.slides.length)
      } else {
        this.showSlide(this.currentSlide - 1)
      }
    }, 500, { leading: true, trailing: false }),
    next: throttle(function () {
      if (this.currentSlide === this.slides.length) {
        this.showSlide(1)
      } else {
        this.showSlide(this.currentSlide + 1)
      }
    }, 500, { leading: true, trailing: false }),
    onPanHorizontal: function (e) {
      const { type } = e
      type === 'panleft' && this.next()
      type === 'panright' && this.prev()
    },
    showSlide: function (index) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.currentSlide = index
      this.timeout = setTimeout(() => this.next(), this.slidesSpeed)
    },
    backgroundStyle: function (background) {
      const { image, color } = background
      if (image !== undefined) {
        return { backgroundImage: `url('${image}')` }
      } else {
        return { backgroundColor: color }
      }
    },
    getLinkClickFunction: function (content) {
      if (content.link.onClickFunc !== undefined) {
        content.link.onClickFunc()
      }
    },
    getButtonClickFunction: function (content) {
      if (content.link.onClickFunc !== undefined) {
        content.link.onClickFunc()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .floatLeft {
    float: left;
  }
  .centerDiv {
    margin: 0 auto;
  }
  .wrapper {
    width: 100%;
  }
  .capitalize {
    text-transform: capitalize;
  }

  .uppercase {
    text-transform: uppercase;
  }

  strong {
    color: white;
  }

  .hero {
    position: relative;
    overflow: hidden;
  }

  .slides {
    position: relative;
    width: 100%;
    min-height: 26rem;
    touch-action: pan-y !important;
  }

  .slide {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: white;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .text {
    flex-direction: column;
    align-items: flex-start;
    width: 470px;
    margin-left: 25%;
    position: relative;
  }

  .text .title {
    width: 100%;
    font-weight: 700;
    font-size: 2.6rem;
    line-height: 3.2rem;
    letter-spacing: 0.1rem;
    color: white;
    padding-bottom: 1.2rem;
    margin-bottom: 0;
    text-align: left;
  }

  .description {
    width: 85%;
    font-size: 1rem;
    line-height: 1.7rem;
    letter-spacing: 0.07rem;
    padding-top: 1.5rem;
    text-align: left;
    position: relative;
    @include mobile {
      padding-top: 1rem;
    }

    &:before {
      position: absolute;
      content: "";
      height: 3px;
      background-color: $primary;
      width: 60px;
      top: 0;
      left: 0;
    }
  }

  .link-container {
    display: flex;
    width: 100%;

    .right-button {
      display: flex;
      align-items: center;
      cursor: pointer;

      &:focus,
      &:focus-within,
      &:active {
        outline: 0;
      }
    }

    .padding-right {
      margin-left: 0.7rem;
    }

    i {
      padding-right: 0.3rem;
    }
  }

  .link {
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    letter-spacing: 0.1rem;
    text-align: center;
    margin-top: 1.5rem;
    padding: 0.5rem 0.7rem;
    border-radius: 0;
    border: none;
    background: $primary;
    color: white;
    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    @include mobile {
      margin-top: 1.25rem;
    }
    &:hover, &:focus, &:active {
      background: darken($primary, 2.5%)
    }
    &.yokogawa {
      background: #FFEE01;
     color: black;
      &:hover, &:focus, &:active {
       background: darken(#FFEE01, 2.5%)
      }
    }
    &.transparent {
      background: rgba(0, 0, 0, 0);
      border: 1px solid white;
      &:hover, &:focus, &:active {
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .image-container {
    margin-right: 2rem;
    .img-logo {
      display: flex;
      width: 100%;
    }
  }

  .buttons {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    bottom: 0;

    .a-button {
      z-index: 5;
      margin: 0.3rem;
      border-radius: 50%;
      height: 15px;
      width: 15px;
      border: 1px solid white;
      cursor: pointer;
    }

    .is-on {
      background-color: white;
    }
  }

  .hero:hover .arrows {
    width: 100%;
    left: 0;
  }

  .arrows {
    position: absolute;
    width: 130%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    left: -15%;
    transition: all 0.5s;

    .a-button {
      z-index: 5;
      margin: 1rem;
      border-radius: 50%;
      height: 40px;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;

      i {
        color: white;
      }
    }
  }

  @include touch {
    .title {
      font-size: 2.5rem;
      line-height: 2.7rem;
    }
    .arrows {
      display: none;
    }
    .image-container {
      margin-right: 0;
      .img-logo {
        display: flex;
        width: 90%;
      }
    }
  }

  @include mobile {
    .buttons {
      bottom: -0.5rem;

      .a-button {
        height: 10px;
        width: 10px;
      }
    }
    .title {
      font-size: 1.8rem;
      line-height: 2.5rem;
    }
    .description {
      width: 75%;
      font-size: 0.95rem;
      line-height: 1.4rem;

      &:before {
        position: absolute;
        content: "";
        height: 3px;
        background-color: $primary;
        width: 60px;
        top: 0;
        left: 0;
      }
    }
    .link {
      font-size: 0.85rem;
    }
    .image-container {
      display: block;
      width: 100%;
      float: none;

      .img-logo {
        display: block;
        width: 25%;
        margin: auto;
      }
    }
  }

  @media (max-width: 700px) {
    .title {
      font-size: 2rem;
      line-height: 2.3rem;
    }
    .image-container {
      top: 0;
      position: absolute;
      margin-top: 1rem;

      .img-logo {
        width: 25%;
        margin: auto;
      }
    }
  }

  @media (max-width: 650px) and (min-width: 600px) {
    .image-container {
      margin-top: 1rem;
    }
  }

  @media (max-width: 550px) {
    .text {
      width: 85%;
      margin: 0 auto;
    }
    .image-container {
      top: 0;
      position: absolute;

      .img-logo {
        width: 25%;
        margin: auto;
      }
    }
  }

  @media (max-width: 480px) {
    .title {
      font-size: 1.8rem;
      line-height: 2rem;
    }
    .text {
      width: 80%;
    }
    .link {
      font-size: 0.75rem;
    }
  }

  @media (max-width: 430px) {
    .text {
      width: 85%;
    }
    .title {
      font-size: 1.6rem;
    }
    .link {
      padding: 0.55rem 0.8rem;
    }
    .image-container {
      top: 0;
      position: absolute;

      .img-logo {
        width: 30%;
        margin: auto;
      }
    }

  }

  @media (max-width: 374px) {
    .link {
      letter-spacing: 0.05rem;
    }

    .image-container {
      top: 0;
      position: absolute;

      .img-logo {
        width: 35%;
        margin: auto;
      }
    }
  }

  .background-image {
    background-position: left;
  }

  .background-image-right {
    background-position: right;
  }

  @media (min-width: 1350px) {
    .background-image {
      background-position: center;
    }
    .background-image-right {
      background-position: center -130px;
    }
  }
  @media (min-width: 1500px) {
    .background-image-right {
      background-position: center -150px;
    }
  }
  @media (min-width: 1650px) {
    .background-image-right {
      background-position: center -170px;
    }
  }
  @media (min-width: 1750px) {
    .background-image-right {
      background-position: center -185px;
    }
  }
  @media (min-width: 1800px) {
    .background-image-right {
      background-position: center -192px;
    }
  }
  @media (min-width: 1850px) {
    .background-image-right {
      background-position: center -200px;
    }
  }
  .background-image-centre {
    background-position: 68%;
  }
</style>
